module.exports = __webpack_public_path__ + "img/Resource.a1f530dc.png";